import { Subscription } from 'rxjs';

import { Component, OnDestroy, OnInit } from '@angular/core';

import { EwidencjaService } from '../../../@core/http/ewidencja.service';
import { SumowanieKwotService } from '../../../@core/utils/sumowanie-kwot.service';
import { Zakup } from '../../../shared/models/zakup.model';
import { ZakresDat } from '../../../shared/models/zakres-dat.model';
import { TranslateService } from '@ngx-translate/core';
import { KomunikatyTabeli, KomunikatyTabeliService } from '../../../@core/utils/komunikaty-tabeli.service';

@Component({
  selector: 'ngx-zakup',
  templateUrl: './zakup.component.html',
  styleUrls: ['./zakup.component.scss'],
})
export class ZakupComponent implements OnInit, OnDestroy {

  dane: Zakup[];
  temp = [];
  eksportKolumny = [];
  eksportPdfKolumnyStyle;
  zakresDat: ZakresDat;
  wyswietlanieFiltrow = false;

  private ewidencjaSubscription: Subscription;

  komunikatyTabeli: KomunikatyTabeli;

  constructor(private readonly ewidencjaService: EwidencjaService,
    private readonly komunikatyTabeliService: KomunikatyTabeliService,
    private readonly translate: TranslateService,
    ) { }

  ngOnInit() {
    this.odswiezKomunikatyTabeli();
    this.translate.onLangChange.subscribe(() => this.odswiezKomunikatyTabeli());

    this.odswiezKolumnyPdf();
    this.translate.onLangChange.subscribe(() => this.odswiezKolumnyPdf());
  }

  ngOnDestroy(): void {
    if (this.ewidencjaSubscription) {
      this.ewidencjaSubscription.unsubscribe();
    }
  }

  updateFilter(event, prop) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function(d) {
      return (d[prop] != null && d[prop].toString().toLowerCase().indexOf(val) !== -1) || !val;
    });
    this.dane = temp;
  }

  onChangeZmianaZakresu(zakresDat: ZakresDat) {
    this.zakresDat = zakresDat;
    this.ewidencjaSubscription = this.ewidencjaService
      .getZakup(zakresDat)
      .subscribe(response => {
        this.temp = [...response];
        this.dane = response;
      });
  }

  sumaKwota(value: number[]) {
    return new SumowanieKwotService().suma(value);
  }

  updateFilterMobile(event) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function(d) {
      return (d.numerDokumentu != null && d.numerDokumentu.toString().toLowerCase().indexOf(val) !== -1) || 
             (d.kontrahent != null && d.kontrahent.toString().toLowerCase().indexOf(val) !== -1) ||
             (d.data != null && d.data.toString().toLowerCase().indexOf(val) !== -1) ||
             (d.opis != null && d.opis.toString().toLowerCase().indexOf(val) !== -1) ||
             !val;
    });
    this.dane = temp;
  }

  sumaNetto(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.netto || 0), 0);
  }

  sumaVat(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.vat || 0), 0);
  }

  sumaBrutto(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.brutto || 0), 0);
  }

  private odswiezKomunikatyTabeli() {
    this.komunikatyTabeli = this.komunikatyTabeliService.get();
  }

  private odswiezKolumnyPdf() {
    this.eksportKolumny = [
      {header: this.translate.instant('etykieta.lp'), dataKey: 'liczbaPorzadkowa'},
      {header: this.translate.instant('etykieta.data'), dataKey: 'data'},
      {header: this.translate.instant('etykieta.nr-dokumentu'), dataKey: 'numerDokumentu'},
      {header: this.translate.instant('etykieta.kontrahent'), dataKey: 'kontrahent'},
      {header: this.translate.instant('etykieta.netto'), dataKey: 'netto'},
      {header: this.translate.instant('etykieta.vat'), dataKey: 'vat'},
      {header: this.translate.instant('etykieta.brutto'), dataKey: 'brutto'},
      {header: this.translate.instant('etykieta.opis'), dataKey: 'opis'},
    ];

    this.eksportPdfKolumnyStyle = {
      liczbaPorzadkowa: { halign: 'right' },
      netto: { halign: 'right' },
      vat: { halign: 'right' },
      brutto: { halign: 'right' },
    };
  }
}
